import { Box, Button, Card, SuccessAnimation, Text } from '@ksyos/design-system';
import { useReloadPatientAvailableActions } from '../../../utils/hooks/useReloadPatientAvailableActions';
import { Container } from '../../elements/molecules/container/Container';
import { PageSection } from '../../elements/molecules/pageSection/PageSection';

export function OsasOptInFlowSuccess() {
    const reloadPatientAvailableActions = useReloadPatientAvailableActions();

    return (
        <Container isFluidOnMobile>
            <PageSection>
                <Card>
                    <Card.Header title="Je slaapzorg is gestart! Vul de vragenlijsten in" />
                    <Card.Body>
                        <Box maxWidth={620}>
                            <Box
                                alignItems="center"
                                display="flex"
                                flexDirection="column"
                            >
                                <Box style={{ marginBottom: '40px', marginTop: '40px' }}>
                                    <SuccessAnimation title="" />
                                </Box>
                            </Box>
                            <Text
                                mb={2}
                                size="md"
                            >
                                Je slaapzorg is gestart! Vul de vragenlijst in via MijnKsyos. Je ontvangt ook een e-mail
                                met informatie over je onderzoek. Nog geen tijd? Vul de vragenlijst later in via de link
                                in je e-mail.
                            </Text>
                        </Box>
                    </Card.Body>
                    <Card.Footer hasBorderTop={false}>
                        <Box
                            display="flex"
                            justifyContent="end"
                        >
                            <Button
                                onClick={async () => {
                                    await reloadPatientAvailableActions();
                                }}
                            >
                                Ga verder naar MijnKsyos
                            </Button>
                        </Box>
                    </Card.Footer>
                </Card>
            </PageSection>
        </Container>
    );
}
